/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const SET_CALCULATED_INTEREST_DATA = 'SET_CALCULATED_INTEREST_DATA';
export const RESET_CALCULATED_INTEREST_DATA = 'RESET_CALCULATED_INTEREST_DATA';
export const SELECTED_INTEREST_DETAILS = 'SELECTED_INTEREST_DETAILS';
export const CALCUALTED_DETAILS_PAYLOAD = 'CALCUALTED_DETAILS_PAYLOAD';
export const RESPONSE_GET_DRUG_INTEREST = 'RESPONSE_GET_DRUG_INTEREST';
export const CALULATED_USER_INPUTS = 'CALULATED_USER_INPUTS';
export const GET_SEARCH_SCREEN_DATA = 'GET_SEARCH_SCREEN_DATA';
export const SELECTED_REBATE_PROGRAM ='SELECTED_REBATE_PROGRAM';
export const SELECTED_MFG ='SELECTED_MFG';
